export const financialStatusConfig = {
  'DRAFT': { label: 'Draft', className: 'bg-gray-100 text-gray-600' },
  'SENT': { label: 'Received', className: 'bg-blue-50 text-blue-600' },
  'PENDING': { label: 'Pending', className: 'bg-orange-50 text-orange-500' },
  'IN_TRANSIT': { label: 'In Transit', className: 'bg-amber-50 text-amber-600' },
  'ACCEPTED': { label: 'Operator Paid', className: 'bg-green-50 text-green-500' },
  'COMPLETED': { label: 'Completed', className: 'bg-green-50 text-green-500' },
  'REJECTED': { label: 'Rejected', className: 'bg-red-50 text-red-600' },
};

export const getFinancialStatusConfig = (status) =>
  financialStatusConfig[status] || { label: status || 'Draft', className: 'bg-gray-100 text-gray-600' };
